import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import 'firebase/messaging'
import { getMessaging, getToken } from 'firebase/messaging'

// Firebase project configurations
const firebaseConfig = {
  apiKey: process.env.REACT_APP_PUBLIC_FIREBASE_APIKEY,
  authDomain: process.env.REACT_APP_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_PUBLIC_FIREBASE_MESSENGER_ID,
  appId: process.env.REACT_APP_PUBLIC_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_PUBLIC_FIREBASE_MESURMENT_ID,
}

// Initialize Firebase
export const app: any = initializeApp(firebaseConfig)

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app)

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app)

export const prepareNotificationToken = async () => {
  try {
    // Initialize Firebase Cloud Messaging and get a reference to the service
    const messaging: any = getMessaging(app)
    const permission: any = await Notification.requestPermission()
    console.log(permission, 'permission')
    if (permission === 'granted') {
      const token = await generateFCMToken(messaging)
      return token // return generated token
    }

    return null // null for not generated token or permission denied
  } catch {
    return null
  }
}

export const generateFCMToken = async (messaging: any) => {
  const token = await getToken(messaging, {
    vapidKey: process.env.REACT_APP_PUBLIC_MESSAGING_KEY,
  })
  return token
}
